export enum SlideDirection {
  Horizontal,
  Vertical
}